module.exports = __webpack_public_path__ + "img/TAAS.0687cd57.svg";